export default "__VITE_ASSET__FzQXn5zd__"